import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import ptCommon from "./locales/pt/common.json";
import enCommon from "./locales/en/common.json";
import ptAuth from "./locales/pt/auth.json";
import enAuth from "./locales/en/auth.json";
import ptNav from "./locales/pt/nav.json";
import enNav from "./locales/en/nav.json";
import ptDashboard from "./locales/pt/dashboard.json";
import enDashboard from "./locales/en/dashboard.json";
import ptEvents from "./locales/pt/events.json";
import enEvents from "./locales/en/events.json";
import ptPromoters from "./locales/pt/promoters.json";
import enPromoters from "./locales/en/promoters.json";
import ptClients from "./locales/pt/clients.json";
import enClients from "./locales/en/clients.json";
import ptInvoices from "./locales/pt/invoices.json";
import enInvoices from "./locales/en/invoices.json";
import ptTemplates from "./locales/pt/templates.json";
import enTemplates from "./locales/en/templates.json";
import ptAlerts from "./locales/pt/alerts.json";
import enAlerts from "./locales/en/alerts.json";
import ptNotifications from "./locales/pt/notifications.json";
import enNotifications from "./locales/en/notifications.json";
import ptUsers from "./locales/pt/users.json";
import enUsers from "./locales/en/users.json";
import ptSettings from "./locales/pt/settings.json";
import enSettings from "./locales/en/settings.json";
import ptOnboarding from "./locales/pt/onboarding.json";
import enOnboarding from "./locales/en/onboarding.json";
import ptWhatsapp from "./locales/pt/whatsapp.json";
import enWhatsapp from "./locales/en/whatsapp.json";
import ptSuperadmin from "./locales/pt/superadmin.json";
import enSuperadmin from "./locales/en/superadmin.json";
import ptPublic from "./locales/pt/public.json";
import enPublic from "./locales/en/public.json";

const resources = {
  pt: {
    common: ptCommon,
    auth: ptAuth,
    nav: ptNav,
    dashboard: ptDashboard,
    events: ptEvents,
    promoters: ptPromoters,
    clients: ptClients,
    invoices: ptInvoices,
    templates: ptTemplates,
    alerts: ptAlerts,
    notifications: ptNotifications,
    users: ptUsers,
    settings: ptSettings,
    onboarding: ptOnboarding,
    whatsapp: ptWhatsapp,
    superadmin: ptSuperadmin,
    public: ptPublic,
  },
  en: {
    common: enCommon,
    auth: enAuth,
    nav: enNav,
    dashboard: enDashboard,
    events: enEvents,
    promoters: enPromoters,
    clients: enClients,
    invoices: enInvoices,
    templates: enTemplates,
    alerts: enAlerts,
    notifications: enNotifications,
    users: enUsers,
    settings: enSettings,
    onboarding: enOnboarding,
    whatsapp: enWhatsapp,
    superadmin: enSuperadmin,
    public: enPublic,
  },
};

// Normalise language codes such as "pt-PT" / "en-GB" to base "pt" / "en"
const normalise = (lng) => {
  if (!lng) return "pt";
  const base = String(lng).toLowerCase().split(/[-_]/)[0];
  return ["pt", "en"].includes(base) ? base : "pt";
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "pt",
    supportedLngs: ["pt", "en"],
    load: "languageOnly",
    ns: [
      "common", "auth", "nav", "dashboard", "events", "promoters", "clients",
      "invoices", "templates", "alerts", "notifications", "users", "settings",
      "onboarding", "whatsapp", "superadmin", "public",
    ],
    defaultNS: "common",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "promocrew_lang",
    },
  });

// Normalise resolved language (browser may report pt-BR / en-US)
const initial = normalise(i18n.language);
if (initial !== i18n.language) i18n.changeLanguage(initial);

export const setLanguage = (lng) => {
  const target = normalise(lng);
  i18n.changeLanguage(target);
  try { localStorage.setItem("promocrew_lang", target); } catch (_e) { /* ignore */ }
};

export default i18n;
